/// <amd-module name="Repos/Tfvc/Views/FilesHub/Components/HistoryContent" />
import * as React from "react";
import { IChangesetsHistoryViewProps } from "Repos/Common/Contracts/History";
import { IFilesHubFilterActionsService } from "Repos/FilesHubCommon/FilesHubFilterActionsService";
import * as Resources from "Repos/Tfvc/Views/FilesHub/Resources";
import { ObservableValue } from "VSS/Core/Observable";
import { PerformanceScenarioContext } from "VSS/Platform/Components/Performance";
import { IVssHistoryService } from "VSS/Platform/History";
import { WrappedComponent } from "VSS/Platform/Layout";
import { HeaderCommandBar } from "VSSUI/HeaderCommandBar";
import { getFilesHubViewService, registerFilesHubTab } from "../FilesHubViewService";

registerFilesHubTab({
    getTab: (pageContext, item, editMode) => {
        if (!item.isInvalid && !editMode) {
            const actionService = pageContext.getService<IFilesHubFilterActionsService>("IFilesHubFilterActionsService");

            const historyService = pageContext.getService<IVssHistoryService>("IVssHistoryService");
            const state = historyService.getState();
            const filterVisible = new ObservableValue<boolean>(
                Boolean(state["toVersion"] || state["fromVersion"] || state["toDate"] || state["fromDate"] || state["user"])
            );

            return {
                id: "history",
                name: Resources.History,
                order: 20,
                render: () => (
                    <PerformanceScenarioContext.Consumer>
                        {scenarioProps => {
                            const pendingWork = scenarioProps.registerPendingWork("load-history");
                            const filesService = getFilesHubViewService(pageContext);
                            return (
                                <WrappedComponent<IChangesetsHistoryViewProps>
                                    wrappedType="repos-changesets-history"
                                    dependencies={["ms.vss-code-web.changesets-list"]}
                                    wrappedProps={{
                                        filterVisible,
                                        filePath: filesService.getSelectedItem().value.path,
                                        isSingleFileHistory: !filesService.getSelectedItem().value.isFolder,
                                        onLoaded: pendingWork && pendingWork.complete,
                                        shouldUpdateUrl: true,
                                        showHeader: false,
                                        version: filesService.getVersion()
                                    }}
                                />
                            );
                        }}
                    </PerformanceScenarioContext.Consumer>
                ),
                renderFilterBar: (inTabBar: boolean) => {
                    return inTabBar ? (
                        <HeaderCommandBar
                            items={[
                                {
                                    ariaLabel: Resources.Filter,
                                    iconProps: { iconName: "Filter" },
                                    id: "filter",
                                    onActivate: () => {
                                        filterVisible.value = !filterVisible.value;
                                    },
                                    subtle: true
                                },
                                ...actionService.getActions()
                            ]}
                        />
                    ) : (
                        undefined
                    );
                }
            };
        }
    },
    dependencies: ["ms.vss-code-web.changesets-list"]
});
